import { render } from "./Parameters.vue?vue&type=template&id=ab9c8d90&ts=true"
import script from "./Parameters.vue?vue&type=script&lang=ts"
export * from "./Parameters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__